export const isScrolledIntoView = (element) => {
  let docViewTop = window.scrollTop();
  let docViewBottom = docViewTop + window.innerHeight;

  let elemTop = element.offsetTop;
  let elemBottom = elemTop + element.innerHeight;
  
  return elemBottom <= docViewBottom && elemTop >= docViewTop;
};

export const isEndOfList = (direction, current, length) =>
(direction < 0 && current === 1) || (direction > 0 && current === length);

let debounceTimer;

export const debounce = (callback, time) => {
  window.clearTimeout(debounceTimer);
  debounceTimer = window.setTimeout(callback, time);
};
